import { AxiosError, AxiosResponse } from 'axios';
import { INetSuiteLog } from '../models';

import { authFetch } from './';

const baseUrl = '/api/Admin';

export const getNetSuiteLog = async (
  beginDate: string,
  endDate: string
): Promise<INetSuiteLog[]> => {
  const response: AxiosResponse<INetSuiteLog[]> = await authFetch.get(
    `${baseUrl}/NetSuiteLog?beginRange=${beginDate}&endRange=${endDate}`
  );

  if (response.status === 200) {
    return response.data;
  }

  if (response.status === 204) {
    return [];
  }

  // Workaround to construct a valid AxiosError.
  // @ts-ignore
  const err: AxiosError = Error(response.statusText);
  err.config = response.config;
  err.isAxiosError = true;
  err.message = response.statusText;
  err.name = `${response.config.method} ${baseUrl}`;
  err.toJSON = () => ({ ...response });
  err.code = '' + response.status;
  err.request = response.request;
  err.response = response;

  throw err;
};
